const msalConfig = {
    auth: {
      clientId: 'fbf10066-88d4-48eb-a5e7-5c20881b56c3',
      authority: 'https://login.microsoftonline.com/9be81a95-7870-42f4-bb8d-a44ada88130a',
      redirectUri: 'http://localhost:3000/layout/home',
      postLogoutRedirectUri: 'http://localhost:3000/login'
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie:false
    }
  };
  
  export default msalConfig;